
import { supabase } from '../supabaseClient';

export interface ForfeoReserveCalendarAssistantOperation {
  targetId: string;
  targetType: 'catalog_item';
  targetLabel: string;
  targetKind: string;
  startsAt: string;
  endsAt: string;
  reasonCode: string;
  explanation: string;
}

export interface ForfeoReserveCalendarAssistantProposal {
  summary: string;
  operations: ForfeoReserveCalendarAssistantOperation[];
}

export async function proposeForfeoReserveCalendarBlocks(input: {
  businessId: string;
  prompt: string;
  selectedTargetId?: string;
  timezone: string;
}): Promise<ForfeoReserveCalendarAssistantProposal> {
  const { data, error } = await supabase.functions.invoke('reserve-calendar-assistant', {
    body: input,
  });

  if (error) throw new Error(error.message || 'calendar_assistant_failed');
  if (!data?.ok) throw new Error(String(data?.error || 'calendar_assistant_failed'));
  if (data.mutationExecuted !== false || data.requiresConfirmation !== true) {
    throw new Error('calendar_assistant_confirmation_contract_invalid');
  }
  return data.proposal as ForfeoReserveCalendarAssistantProposal;
}
